// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"31d6cfe0","244":"31d6cfe0","277":"31d6cfe0","532":"0f033c84","625":"31d6cfe0"}[chunkId] + ".chunk.css";
};